<template>
  <span>
    <v-layout mb-4>
      <v-flex xs10 ml-3>
        <h2 class="lime--text lighten-1 pt-3">Gerenciar Usuários - Edição</h2>
      </v-flex>
      <v-flex xs2 text-right>
        <v-btn color="blue-grey" class="black--text" @click.prevent="voltar">
          <v-icon dark>keyboard_arrow_left</v-icon>
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>

    <form-edit-user :user="user" :update="true"></form-edit-user>
  </span>
</template>

<script>
import FormEditUserComponent from "./partial/FormEditUserComponent";

export default {
  name: "EditUserComponent",
  created() {
    this.loadUser();
  },
  props: {
    usu_id: {
      require: true
    }
  },
  data() {
    return {
      user: {
        usu_id: "",
        department_id: "",
        username: "",
        email: "",
        usu_nome: "",
        usu_cnpj: "",
        usu_ie: "",
        usu_cpf: "",
        usu_rg: "",
        usu_prefixo: "",
        usu_fone1: "",
        usu_celular: "",
        usu_foto: "",
        usu_status: true,
        usu_admin: false,
        usu_funcionario: true,
        usu_usuario: false,
        usu_profissao: ""
      },
      upload: null,
      fileName: "Selecione uma foto",
      preview: null,
      langs: true
    };
  },
  methods: {
    voltar() {
      history.back();
    },
    loadUser() {
      this.$store
        .dispatch("loadUser", this.usu_id)
        .then(response => {
          this.user = response;
        })
        .catch(error => {
          this.$swal({
            position: "center",
            type: "error",
            title: "Erro",
            text: "Dados não localizado",
            showConfirmButton: true,
            timer: 6000
          });
        });
    }
  },
  components: {
    formEditUser: FormEditUserComponent
  }
};
</script>

<style scoped></style>
